import './Loading.css';

export default function Loading({ text = 'Chargement...' }) {
  return (
    <div className="loading" role="status">
      <div className="loading__spinner" />
      <p className="loading__text chiron-goround-tc-body">{text}</p>
    </div>
  );
}
